import ForgotPassword from './modules/forgot-password';
import Login from './modules/login';
import Menu from './modules/menu';
import Search from './modules/search';
import SelectAccount from './modules/select-account';
const advancedSearchForm = document.getElementById('advanced-search-form');
const forgotPasswordSpan = document.getElementById('forgot-password-span');
const forgotPasswordForm = document.getElementById('forgot-password-form');
const loginBtn = document.getElementById('login-btn');
const loginForm = document.getElementById('login-form');
const menuBtn = document.getElementById('menu-btn');
const menuList = document.getElementById('menu-list');
const partNumberSearchForm = document.getElementById('part-number-search-form');
const selectAccountAnchor = document.getElementById('select-account-anchor');
const selectAccountForm = document.getElementById('select-account-form');
const vehicleSearchForm = document.getElementById('vehicle-search-form');
const vinSearchForm = document.getElementById('vin-search-form');
if (loginBtn instanceof HTMLButtonElement &&
    loginForm instanceof HTMLFormElement) {
    const login = new Login(loginBtn, loginForm);
    if (forgotPasswordSpan instanceof HTMLSpanElement &&
        forgotPasswordForm instanceof HTMLFormElement) {
        new ForgotPassword(forgotPasswordSpan, forgotPasswordForm, login);
    }
}
if (menuBtn instanceof HTMLButtonElement &&
    menuList instanceof HTMLUListElement) {
    const menu = new Menu(menuBtn, menuList);
    if (selectAccountAnchor instanceof HTMLAnchorElement &&
        selectAccountForm instanceof HTMLFormElement) {
        new SelectAccount(selectAccountAnchor, selectAccountForm, menu);
    }
}
if (vehicleSearchForm instanceof HTMLFormElement &&
    vinSearchForm instanceof HTMLFormElement &&
    partNumberSearchForm instanceof HTMLFormElement &&
    advancedSearchForm instanceof HTMLFormElement) {
    new Search(vehicleSearchForm, vinSearchForm, partNumberSearchForm, advancedSearchForm);
}
// Check that service workers are supported
if ('serviceWorker' in navigator) {
    // Use the window load event to keep the page load performant
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/service-worker.js');
    });
}
window.googleRecaptchaOnSubmit = (token) => {
    if (vinSearchForm instanceof HTMLFormElement) {
        vinSearchForm.submit();
    }
};
// Présenter un spinner aux utilisateurs afin de les faire patienter.
// Simplement ajouter la classe « add-spinner » aux éléments qui pointent
// vers des pages qui sont susceptibles de prendre du temps à charger.
window.addEventListener('click', (ev) => {
    const target = ev.target;
    if (!(target instanceof HTMLElement)) {
        return;
    }
    if (!target.closest('.add-spinner')) {
        return;
    }
    const form = target.closest('form');
    if (form) { // Vérifier si on a un formulaire, avant de vérifier s'il est valide
        if (!form.checkValidity()) {
            return;
        }
    }
    const spinnerContainer = document.createElement('div');
    spinnerContainer.className = 'spinner-container';
    const spinner = document.createElement('div');
    spinner.className = 'spinner';
    spinnerContainer.appendChild(spinner);
    document.body.appendChild(spinnerContainer);
});
